<template>
  <div class="filter-container flex-row">
    <div class="filter-op">
      <ms-validate ref="validateObserver">
        <menu-wrapper>
          <template #menu-button="{ toggleMenu }">
            <button
              tabindex="-1"
              @click="toggleMenu"
              class="btn-filter-operator"
            >
              <div :class="['icon24', nativeFilterIconClass]"></div>
            </button>
          </template>
          <template #menu-content>
            <template v-for="(item, i) in filterOperators" :key="i">
              <menu-item
                class="filter-operator-item"
                :class="item.enumValue === operatorValue ? 'active' : ''"
                @menu-item-click="filterOperatorItemClick(item)"
                :icon="['icon24', item.icon]"
                >{{ item?.enumText }}</menu-item
              >
            </template>
          </template>
        </menu-wrapper>
      </ms-validate>
    </div>
    <div class="filter-value flex">
      <ms-number
        :readOnly="operatorValueReadonly"
        ref="filterInput"
        v-model="filterValue"
        :hasBorder="false"
        @keyup.enter="
          filterHeaderHandle({ operator: operatorValue, value: filterValue })
        "
        @blur="
          filterHeaderHandle({ operator: operatorValue, value: filterValue })
        "
        :formatType="col.formatType || col.dataFormat"
        class="w-full ms-input-filter-value"
      />
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import msThOptionBase from '@/components/gridViewer/columnOption/MsThOptionBase.js';
import msValidate from '@/components/validate/MsValidate.vue';
import MenuItem from '@/components/dropdown/MenuItem.vue';
import MenuWrapper from '@/components/dropdown/MenuWrapper.vue';
import setup from '@/components/gridViewer/columnOption/render-helper.js';
export default defineComponent({
  extends: msThOptionBase,
  components: {
    msValidate,
    MenuItem,
    MenuWrapper,
  },
  name: 'MsThOptionNumber',
  props: {
    filterIconClass: {
      type: String,
      default: 'ic-filter-equal',
    },
  },
  setup(props, { emit }) {
    const {
      nativeFilterIconClass,
      operatorValue,
      operatorValueReadonly,
      filterValue,
      filterInput,
      filterHeaderHandle,
      filterOperators,
      removeFilter,
      filterOperatorItemClick,
    } = setup(props, { emit });

    //Hooks

    return {
      nativeFilterIconClass,
      filterOperators,
      operatorValue,
      filterValue,
      filterInput,
      filterHeaderHandle,
      operatorValueReadonly,
      removeFilter,
      filterOperatorItemClick,
    };
  },
});
</script>
